export default __webpack_public_path__ + "static/media/Reason 2.e0797aa8.mp3";